<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex class="pr-lg-1" xs12>
                <AccountChart :type="type" />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
// import AccountCardContent from "@/components/AccountCardContent.vue";
import AccountChart from "@/components/AccountChart.vue";

export default {
    name: "Account",
    components: {
        AccountChart
    },
    data() {
        return {
            type: this.$route.fullPath.split("/").pop(),
            logo: "../assets/instagram.svg",

            item: {
                name: "tiktok",
                logo: "../assets/tik-tok.svg",
                next_pay: "25 september",
                followers: "20999",
                comments: "20999",
                likes: "29099"
            }
        };
    },
    watch: {
        '$route': function() {
            this.loadData();
        },
    },
    created: function() {
        this.loadData();
    },
    methods: {
        loadData(){
            let type = this.$route.fullPath.split("/").pop();
            if (type.indexOf('?') !== -1) {
              type = type.substring(0, type.indexOf('?'));
            }
            console.log(type);
            this.type = type;
            if (type != "instagram") {
                this.logo = "../assets/tik-tok.svg";
            }
            this.$root.breadcrumbs = [
                {
                    text: "Home",
                    href: "/dashboard"
                },
                {
                    text: type[0].toUpperCase() + type.slice(1),
                    href: `/${type}`,
                    icon: "../assets/arrow.svg"
                },
                {
                    text: "Accounts",
                    icon: "../assets/arrow.svg"
                }
            ];
        },
        goToShop() {
            this.$router.push({ path: "shop" });
        }
    }
};
</script>

<style>
.channels_card {
    border-radius: 20px !important;
    overflow: hidden;
}
.channels_box {
    position: relative;
}
.channel {
    width: 50px;
    height: 50px;
    position: absolute;
    top: 0;
    border-radius: 50%;
}
.channel:first-child {
    left: 0;
}
.channel:nth-child(2n) {
    left: 25px;
}
.channel:nth-child(3n) {
    left: 50px;
}
.card_title {
    color: #2c4370;
}
.next_payment {
    font-size: 14px;
    line-height: 17px;
}
.payment_date {
    font-size: 20px;
    line-height: 24.38px;
}
.followers_sum {
    color: #172745;
    font-size: 26px;
    line-height: 1em;
}
.followers_title {
    color: #172745;
    font-size: 14px;
    line-height: 17px;
}
.buy_btn {
    text-transform: none !important;
    font-size: 18px !important;
}
.theme--light.v-divider {
    border-color: #c8d3e9 !important;
}
.view_channels_btn {
    text-transform: none !important;
    font-size: 18px !important;
    font-weight: normal !important;
}
.empty_card {
    opacity: 0.6;
    filter: blur(2px);
}
.expand_icon {
    font-size: 50px !important;
    color: #172745 !important;
}
</style>
